export default __webpack_public_path__ + "static/media/Gold Category.00978825.svg";